import React, { memo } from 'react';
import { X } from 'lucide-react';
import { Section } from './Shared';
export const PainPoints = () => {
  const points = ['Cargando el dolor sola/o sin saber cómo procesarlo o dónde volcarlo.', 'Sintiendo culpa por las cosas que no llegaste a decirle.', 'Sin herramientas para atravesar los días más difíciles: su cumpleaños, el Día de la Madre, la Navidad.', 'Sin poder distinguir entre recordarla con amor y quedarte atrapada/o en el sufrimiento.', 'Sintiéndote abandonada/o, como si hubieras perdido tu brújula y tu refugio al mismo tiempo.', 'Sin entender cómo honrar su memoria sin congelar tu propia vida.', 'Creyendo que si avanzás, la estás traicionando.', 'Cada día despertándote sin saber cómo llevar ese peso.'];
  return <Section className="max-w-4xl" data-id="element-255">
      <div className="text-center mb-12" data-id="element-256">
        <h2 className="text-2xl md:text-4xl lg:text-5xl font-display font-bold mb-6 leading-tight text-brand-pinkDark" data-id="element-257">
          ¿Cuántos días más vas a cargar sola con ese dolor?
        </h2>
        <p className="text-brand-text/80 mb-4 text-sm md:text-base max-w-2xl mx-auto" data-id="element-258">
          Perdiste físicamente a tu mamá. La amabas. Y nadie te preparó para
          esto. Nadie te dijo que ibas a mirar el celular esperando su llamado.
          Que ibas a querer contarle algo y que en ese segundo ibas a recordar
          que ya no está. Que las fechas especiales iban a doler de una forma
          que no tiene nombre. Que ibas a sentir culpa por reírte, por avanzar,
          por olvidar por un momento que ella ya no está físicamente.
        </p>

        <p className="text-lg md:text-xl font-medium text-brand-pink mt-6 font-serif italic" data-id="element-259">
          No es debilidad. Es amor. Y ese amor necesita un lugar donde ir.
        </p>
      </div>

      <div className="glass-panel p-6 md:p-10 rounded-3xl mb-12 bg-white/70 border-brand-pink/20" data-id="element-260">
        <h3 className="font-serif font-bold mb-6 flex items-center text-brand-pinkDark text-base md:text-lg" data-id="element-261">
          <X className="w-6 h-6 text-brand-dark mr-2 shrink-0" data-id="element-262" /> Lo que pasa
          sin el Santuario Digital:
        </h3>
        <ul className="space-y-4" data-id="element-263">
          {points.map((point, i) => <li key={i} className="flex items-start" data-id="element-264">
              <X className="w-5 h-5 text-brand-dark/80 mr-3 mt-0.5 shrink-0" data-id="element-265" />
              <span className="text-brand-text/80 text-sm md:text-base" data-id="element-266">
                {point}
              </span>
            </li>)}
        </ul>
      </div>

      <div className="text-center" data-id="element-267">
        <h3 className="text-xl md:text-3xl font-display font-bold pink-gradient-text" data-id="element-268">
          ¿Y si hoy fuera el día en que el dolor empieza a transformarse?
        </h3>
      </div>
    </Section>;
};